import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'bmcore-logo',
  templateUrl: './bmcore-logo.component.html',
  styleUrls: ['./bmcore-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreLogoComponent implements OnInit {
  @Input() logoUrl: string
  @Input() beatmakerName: string

  constructor() {}

  ngOnInit(): void {}
}
